export enum MCIContext {
    None,
    Argentina,
    GenASysDB,
    ATPCARRINT,
    Excel
}